import { React, useState } from 'react';
import GoToPage from './goToPage';
const Card = (props) => {
    const { image, icon, title, page } = props;
    const [handle, setHandle] = useState(false);

    const handleOver = () => {
        setHandle(true);
    }
    const handleOut = () => {
        setHandle(false);
    }

    return (
        <div className="h-full w-full lg:py-0 md:py-0 sm:py-3 py-3" onMouseEnter={handleOver} onMouseLeave={handleOut}>

            {handle ?

                //relative overflow-hidden rounded-lg shadow-lg cursor-pointer
                <div className=" transition delay-200 duration-1000 text-center w-full h-[27rem] place-items-center cursor-pointer relative overflow-hidden ">
                    <img loading="lazy" className="object-cover h-full w-full" src={image} alt="" />
                    <div className="absolute bottom-0 text-center text-white px-6  w-full pb-[4rem] flex justify-center items-center ">
                        <GoToPage
                        page={page}
                        side="right"
                        name="Ver especies"
                        fontsize="text-xl"
                        textType="font-bold"
                        textColor="text-white"
                        borderType="border-b-2"
                        borderColor="border-white"
                        iconSize="h-4"
                        iconColor="invert"
                        iconMargin="ml-5"
                      ></GoToPage>
                    </div>
                </div>
                :
                <div className="transition duration-700 bg-[#091a2c]/30 pt-10 text-center w-full h-[27rem]  place-items-center relative">
                    <div className="w-full flex justify-center items-center mt-5">
                        <img loading="lazy" src={icon} className="opacity-100 z-50" ></img>
                    </div>
                    <div className="2xl:text-5xl xl:text-3xl lg:text-xl md:text-4xl sm:text-4xl text-4xl mt-10 mb-10 w-full text-center">
                        {title}
                    </div>
                    <div className="absolute bottom-0 text-center text-white px-6  w-full pb-[4rem] flex justify-center items-center ">
                        <GoToPage
                        page={page}
                        side="right"
                        name="Ver especies"
                        fontsize="text-xl"
                        textColor="text-white"
                        textType="font-bold"
                        borderType="border-b-2"
                        borderColor="border-white"
                        iconSize="h-4"
                        iconColor="invert"
                        iconMargin="ml-5"
                      ></GoToPage>
                    </div>
                </div>

            }

        </div>
    );
}

export default Card;

/*
 image={}
                            icon={}
                            title={}
                            page={"../grupos"}
                            buttonText={"Link"}
*/